import { InputDevice, ButtonState } from "./InputDevice";
import { InputDeviceType } from "flavr-common";
import { BUTTON_MAPPING } from "./InputMapping";
import { ENVIRONMENT_IS_WEB } from "../../../messages/environment";
export class KeyboardInputDevice extends InputDevice {
    constructor(uid, pendingMessages, enabled) {
        super(uid, pendingMessages, enabled);
        this.keys = {};
        this.onKeydown = (e) => {
            if (e.target !== document.body && ENVIRONMENT_IS_WEB)
                return;
            const key = this.getKey(e.key);
            this.onButtonPress(key);
        };
        this.onKeyup = (e) => {
            if (e.target !== document.body && ENVIRONMENT_IS_WEB)
                return;
            const key = this.getKey(e.key);
            this.onButtonRelease(key);
        };
        document.addEventListener("keydown", this.onKeydown);
        document.addEventListener("keyup", this.onKeyup);
    }
    getKey(keyName) {
        const key = this.keys[keyName];
        if (key)
            return key;
        const mapping = BUTTON_MAPPING[InputDeviceType.Keyboard];
        return (this.keys[keyName] = {
            type: mapping ? mapping[keyName] : undefined,
            state: ButtonState.RELEASED,
            lastChangeTimeStamp: 0,
            doubleClick: false
        });
    }
    updateButtonMapping(buttonId, type) {
        const key = this.keys[buttonId];
        if (key) {
            this.onButtonTypeChanged(key, type);
        }
    }
    forEachButton(callback) {
        for (const keyName in this.keys) {
            callback(this.keys[keyName]);
        }
    }
}
